export default __webpack_public_path__ + "static/media/logo.9aca8e63.svg";